exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#if {\n  font-size: 1.3rem;\n  color: #EAEAEB;\n  font-weight: bold; }\n  #if .text {\n    width: 1.8rem;\n    text-align: center; }\n  #if .MuiButtonBase-root {\n    min-width: 1.8rem;\n    width: 1.8rem; }\n  #if .MuiButtonBase-root {\n    display: none; }\n  #if:hover .text {\n    display: none; }\n  #if:hover .MuiButtonBase-root {\n    display: block; }\n", ""]);

// exports
